"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const BackdropModal = ({ childrenPosition = 'flex-end', onRequestClose, children, visible, style, }) => {
    return (react_1.default.createElement(react_native_1.Modal, { animationType: "fade", onRequestClose: onRequestClose, visible: visible, transparent: true },
        react_1.default.createElement(react_native_1.View, { style: react_native_1.StyleSheet.flatten([styles.container, { justifyContent: childrenPosition }, style]) },
            react_1.default.createElement(react_native_1.TouchableWithoutFeedback, { onPress: onRequestClose },
                react_1.default.createElement(react_native_1.View, { style: styles.backdrop })),
            react_1.default.createElement(react_native_1.View, null, children))));
};
exports.default = BackdropModal;
const styles = react_native_1.StyleSheet.create({
    container: {
        flex: 1,
        ...react_native_1.Platform.select({
            web: {
                touchAction: 'none',
            },
        }),
    },
    backdrop: {
        position: 'absolute',
        flex: 1,
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'rgba(18, 18, 18, 0.5)',
    },
});
